import { useQuery } from "react-query";
import { getProducerCodeType } from "../../../../../actions/Utilities/ProducerCodeType/index";

export const useProducerCodeType = () => {
  const { data, isFetching } = useQuery(
    "GetProducerCodeType",
    getProducerCodeType,
    {
      refetchOnWindowFocus: false,
    }
  );
  return { data, isFetching };
};
